import * as types from './types';

function setPlaceGuideContent(data, placeGuideId) {
    return {
        meta: placeGuideId,
        payload: data,
        type: types.SET_PLACE_GUIDE_CONTENT,
    };
}

export {
    setPlaceGuideContent,
};

export default {
    setPlaceGuideContent,
};
